<template>
  <!-- Several contacts match (e.g. an email's From/To/Cc) — switch between them -->
  <div v-if="alternates.length > 1" class="flex flex-wrap gap-1.5 flex-shrink-0 mb-2">
    <button
      v-for="c in alternates" :key="c.id"
      @click="$emit('pick', c.id)"
      class="text-xs px-2 py-0.5 rounded-full border transition-colors"
      :class="c.id === contactId
        ? 'bg-blue-600 border-blue-600 text-white'
        : 'border-stroke dark:border-stroke-dark text-fg-secondary dark:text-fg-secondary-dark hover:bg-surface-muted dark:hover:bg-surface-muted-dark'"
    >{{ c.name }}</button>
  </div>
  <ContactPanel
    v-if="contact"
    class="!w-full !max-h-full flex-1 min-h-0 !bg-transparent !top-0"
    :contact="contact"
    @close="$emit('close')"
    @changed="onChanged"
  />
  <div v-else class="flex-1 p-4 text-sm text-fg-faint dark:text-fg-faint-dark">
    {{ failed ? 'Couldn’t load this contact.' : 'Loading…' }}
  </div>
</template>

<script setup>
// ContactPanel by id, for AdminSidebar.vue.
import { ref, watch } from 'vue'
import { useApi } from '../../composables/useApi.js'
import { useAdminSidebar } from '../../composables/useAdminSidebar.js'
import ContactPanel from './ContactPanel.vue'

const props = defineProps({
  contactId:  { type: Number, required: true },
  alternates: { type: Array, default: () => [] },  // [{ id, name }]
})
const emit = defineEmits(['close', 'pick', 'title'])  // title: the contact's name, for the sidebar tab

const { fetchApi } = useApi()
const { notifyContactsChanged } = useAdminSidebar()
const contact = ref(null)
const failed = ref(false)

async function load() {
  const id = props.contactId
  try {
    const c = await fetchApi(`/api/contacts/${id}`)
    if (props.contactId !== id) return
    contact.value = c
    failed.value = false
    emit('title', c.name || '(No name)')
  } catch {
    if (props.contactId === id && !contact.value) failed.value = true
  }
}
function onChanged() {
  load()
  notifyContactsChanged()
}
watch(() => props.contactId, () => { contact.value = null; failed.value = false; load() }, { immediate: true })
</script>
